import { useState } from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";

const AddEmojiForm = ({ selectedEmoji, link, setLink, onPaymentSuccess }) => {
  const [isPaying, setIsPaying] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedEmoji || !link) return;
    setIsPaying(true);
  };

  return (
    <div className="p-4 text-center">
      <h2 className="text-lg font-bold mb-4">If Your Brand Were an Emoji, Which One Would It Be?</h2>

      {selectedEmoji ? (
        <div className="text-5xl mb-4">{selectedEmoji}</div>
      ) : (
        <p className="text-gray-500 mb-4">Select an Emoji from the menu.</p>
      )}

      <form
        onSubmit={handleSubmit}
        className="flex flex-col md:flex-row items-center gap-4 w-full md:w-3/4 mx-auto"
      >
        <input
          type="url"
          value={link}
          onChange={(e) => setLink(e.target.value)}
          placeholder="https://yourwebsite.com"
          className="flex-1 p-3 border border-gray-300 rounded-lg shadow-sm text-center text-sm md:text-base w-full md:w-auto"
          required
        />

        <button
          type="submit"
          className={`p-3 text-white rounded-lg w-full md:w-auto ${
            selectedEmoji
              ? "bg-blue-500 hover:bg-blue-600 transition-all"
              : "bg-gray-400 cursor-not-allowed"
          }`}
          disabled={!selectedEmoji}
        >
          Pay&Add
        </button>
      </form>

      {isPaying && (
        <div className="mt-4">
          <PayPalButtons
            style={{ layout: "horizontal" }}
            createOrder={(data, actions) => {
              return actions.order.create({
                purchase_units: [{ amount: { value: "20.00" } }],
              });
            }}
            onApprove={async (data, actions) => {
              await actions.order.capture();
              onPaymentSuccess();
              setIsPaying(false);
            }}
            onCancel={() => setIsPaying(false)}
          />
        </div>
      )}
    </div>
  );
};

export { AddEmojiForm };
